import { blinkConstants } from '@thoughtspot/blink-constants';
import { GetBlobService } from '@thoughtspot/custom-style-service';
import { IconID } from '@thoughtspot/radiant-react/widgets/icon';
import { getReplayLinkBaseUrl } from '@thoughtspot/session-service';
import React from 'react';
import { HelpMenuItemTrackIds } from "../../utils/metrics.util";
import { CustomMenuItem } from '../custom-menu-item/custom-menu-item';
import { DeprecatedHelpItemIds, DeprecatedHelpItems, HelpMenuState, SupportConfigItemIds, } from './help-menu.const';
const getSupportMenuItem = (isIntercomEnabled, onReplayStarted, openExternalUrlInNewTab, releaseVersion, sendItemClickEvent, setHelpMenuState, translate, watchForFullReplay, userRole) => {
    const replayLinkBaseUrl = getReplayLinkBaseUrl();
    if (isIntercomEnabled && window.Intercom) {
        return {
            id: SupportConfigItemIds.CONTACT_SUPPORT,
            onClick: () => {
                sendItemClickEvent(HelpMenuItemTrackIds.CONTACT_SUPPORT);
                watchForFullReplay?.((replayID) => {
                    window.Intercom('trackEvent', 'initialized_replay', {
                        replayID,
                        replayLink: `${replayLinkBaseUrl}${replayID}`,
                        sentry_id: replayID,
                        cluster_url: window.location.origin,
                        cluster_version: releaseVersion,
                        user_role: userRole,
                    });
                    window.Intercom('update', {
                        sentry_id: replayID,
                    });
                    onReplayStarted();
                }, () => undefined);
                window.Intercom('update', {
                    cluster_url: window.location.origin,
                    cluster_version: releaseVersion,
                    user_role: userRole,
                });
                window.Intercom('show');
                window.Intercom('onShow', () => {
                    setHelpMenuState(HelpMenuState.CLOSED);
                });
            },
            customContent: (React.createElement(CustomMenuItem, { config: {
                    name: translate('helpMenuItems.contactSupport.label'),
                    description: translate('helpMenuItems.contactSupport.description'),
                    icon: IconID.COMMUNITY,
                    id: SupportConfigItemIds.CONTACT_SUPPORT,
                    target: {
                        callback: () => {
                            window.Intercom('update', {
                                cluster_url: window.location.origin,
                                cluster_version: releaseVersion,
                                user_role: userRole,
                            });
                            window.Intercom('show');
                            window.Intercom('onShow', () => {
                                setHelpMenuState(HelpMenuState.CLOSED);
                            });
                        },
                    },
                } })),
        };
    }
    const supportNavLink = {
        name: translate('helpMenuItems.reportAProblem.label'),
        description: translate('helpMenuItems.reportAProblem.description'),
        icon: IconID.EXCLAMATION_POINT_CIRCLE,
        id: SupportConfigItemIds.CONTACT_SUPPORT,
        target: {
            callback: () => {
                openExternalUrlInNewTab(blinkConstants.help.CONTACT_SUPPORT);
                setHelpMenuState(HelpMenuState.CLOSED);
            },
        },
    };
    return {
        id: SupportConfigItemIds.CONTACT_SUPPORT,
        onClick: () => {
            sendItemClickEvent(HelpMenuItemTrackIds.CONTACT_SUPPORT);
            openExternalUrlInNewTab(blinkConstants.help.CONTACT_SUPPORT);
        },
        customContent: React.createElement(CustomMenuItem, { config: supportNavLink }),
    };
};
const getDefaultMenuItems = (documentationUrl, releaseNotesUrl, sendItemClickEvent, setHelpMenuState, translate, whatsNewUrl) => {
    return [
        {
            id: SupportConfigItemIds.HELP,
            onClick: () => {
                sendItemClickEvent(HelpMenuItemTrackIds.HELP);
                setHelpMenuState(HelpMenuState.DOCUMENTATION);
            },
            customContent: (React.createElement(CustomMenuItem, { config: {
                    name: translate('helpMenuItems.help.label'),
                    description: translate('helpMenuItems.help.description'),
                    icon: IconID.DOCUMENTATION,
                    id: SupportConfigItemIds.HELP,
                    target: {
                        callback: () => {
                            setHelpMenuState(HelpMenuState.DOCUMENTATION);
                        },
                        routerURI: documentationUrl,
                    },
                } })),
        },
        {
            id: SupportConfigItemIds.GETTING_STARTED,
            onClick: () => {
                sendItemClickEvent(HelpMenuItemTrackIds.GETTING_STARTED);
                setHelpMenuState(HelpMenuState.GETTING_STARTED);
            },
            customContent: (React.createElement(CustomMenuItem, { config: {
                    name: translate('helpMenuItems.gettingStarted.label'),
                    description: translate('helpMenuItems.gettingStarted.description'),
                    icon: IconID.VIDEO,
                    id: SupportConfigItemIds.GETTING_STARTED,
                    target: {
                        callback: () => {
                            setHelpMenuState(HelpMenuState.GETTING_STARTED);
                        },
                        routerURI: releaseNotesUrl,
                    },
                } })),
        },
        {
            id: SupportConfigItemIds.WHATS_NEW,
            onClick: () => {
                sendItemClickEvent(HelpMenuItemTrackIds.WHATS_NEW);
                setHelpMenuState(HelpMenuState.WHATS_NEW);
            },
            customContent: (React.createElement(CustomMenuItem, { config: {
                    name: translate('helpMenuItems.whatsNew.label'),
                    description: translate('helpMenuItems.whatsNew.description'),
                    icon: IconID.ROCKET,
                    id: SupportConfigItemIds.WHATS_NEW,
                    target: {
                        callback: () => {
                            setHelpMenuState(HelpMenuState.WHATS_NEW);
                        },
                        routerURI: whatsNewUrl,
                    },
                } })),
        },
    ];
};
const getCustomLinks = (customLinks, baseReleaseVersion, docsUrl, isSaasCluster, openExternalUrlInNewTab, toggleHelpMenu, translate) => {
    if (customLinks.every(link => DeprecatedHelpItemIds.includes(link.id) &&
        link.url.includes('{docsUrl}'))) {
        return null;
    }
    const menuItems = customLinks
        .filter(link => link.enabled &&
        (!isSaasCluster ||
            link.id !== DeprecatedHelpItems.BLINK_DOWNLOADS))
        .map(enabledLink => {
        const label = translate(enabledLink.title);
        const onClick = () => {
            if (enabledLink.url.match(blinkConstants.URL_REGEX)) {
                openExternalUrlInNewTab(enabledLink.url
                    .replace('{versionNameForLink}', baseReleaseVersion)
                    .replace('{docsUrl}', docsUrl));
            }
            toggleHelpMenu();
        };
        return {
            id: enabledLink.id,
            label,
            onClick,
            customContent: (React.createElement(CustomMenuItem, { config: {
                    name: label,
                    id: enabledLink.id,
                    iconImageUrl: enabledLink.iconFilePath
                        ? GetBlobService.getBlobUrl(enabledLink.iconFilePath)
                        : undefined,
                    target: {
                        callback: onClick,
                    },
                } })),
        };
    });
    if (menuItems.length) {
        return {
            title: '',
            items: menuItems,
        };
    }
    return null;
};
export const getDocumentationUrls = (onlineDocUrl, inAppHelpUrl, baseReleaseVersion) => {
    return {
        documentationUrl: inAppHelpUrl.replaceAll('{versionNameForLink}', baseReleaseVersion),
        whatsNewUrl: `${onlineDocUrl}latest/coming-soon-${baseReleaseVersion.replaceAll('.', '-')}`,
        releaseNotesUrl: `${onlineDocUrl}${baseReleaseVersion}/notes`,
    };
};
export const getHelpMenuItems = (baseReleaseVersion, documentationUrl, helpItems, isAppEmbedded, isIntercomEnabled, isSaasCluster, onReplayStarted, openExternalUrlInNewTab, releaseNotesUrl, setHelpMenuState, supportConfigItems, t, toggleHelpMenu, watchForFullReplay, whatsNewUrl, isAboutInstanceModalEnabled, releaseVersion, sendItemClickEvent, userRole) => {
    const menuItemGroups = [];
    const defaultMenuItems = [];
    if (helpItems.every(item => !item.enabled ||
        !DeprecatedHelpItemIds.includes(item.id) ||
        item.url.includes('{docsUrl}'))) {
        getDefaultMenuItems(documentationUrl, releaseNotesUrl, sendItemClickEvent, setHelpMenuState, t, whatsNewUrl).forEach(defaultMenuItem => {
            if (supportConfigItems.some(item => item.id === defaultMenuItem.id && item.enabled)) {
                defaultMenuItems.push(defaultMenuItem);
            }
        });
    }
    if (!isAppEmbedded &&
        supportConfigItems.find(item => item.id === SupportConfigItemIds.CONTACT_SUPPORT &&
            item.enabled)) {
        defaultMenuItems.push(getSupportMenuItem(isIntercomEnabled, onReplayStarted, openExternalUrlInNewTab, releaseVersion, sendItemClickEvent, setHelpMenuState, t, watchForFullReplay, userRole));
    }
    if (isAboutInstanceModalEnabled) {
        const openAboutModal = () => {
            sendItemClickEvent(HelpMenuItemTrackIds.ABOUT_INSTANCE);
            setHelpMenuState(HelpMenuState.ABOUT_INSTANCE);
        };
        defaultMenuItems.push({
            id: SupportConfigItemIds.ABOUT_INSTANCE,
            onClick: openAboutModal,
            customContent: (React.createElement(CustomMenuItem, { config: {
                    name: t('helpMenuItems.aboutInstance.label'),
                    description: `${t('Version')} ${releaseVersion}`,
                    icon: IconID.ABOUT,
                    id: SupportConfigItemIds.ABOUT_INSTANCE,
                    target: {
                        callback: openAboutModal,
                    },
                } })),
        });
    }
    if (defaultMenuItems.length) {
        menuItemGroups.push({
            title: '',
            items: defaultMenuItems,
        });
    }
    const customLinks = getCustomLinks(helpItems, baseReleaseVersion, documentationUrl, isSaasCluster, openExternalUrlInNewTab, toggleHelpMenu, t);
    if (customLinks) {
        menuItemGroups.push(customLinks);
    }
    return menuItemGroups;
};
//# sourceMappingURL=help-menu.util.js.map